<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import strparam from "@/models/StrParam";
import store from "@/state/store";
export default {
  mixins: [Api, Sabit, strparam],
  props: ["Id2"],
  data() {
    return {
    OPersonelid: null,
      FormData: {},
      UserEmail : store.getters["auth/UserEMail"],
      FormDatas: [],
      Hesapkoduids: [],
      Strperformanshedefiid: "",
      Strtabdetfaaliyetid: "",
      guncele: "Add",
      file: "",
      aktif_arama: false,
      AdminRoleKontrol: false,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
      },
      Hesapkodlari: [],
    };
  },
  components: {
    Loader,
    forminput,
  },
  methods: {
    onSubmit() {
                this.Update("StrParam", this.FormData).then(
                  (res) => {
                    if (res) {
                      this.$emit("UpdateSonGun");
                                    this.$bvModal.hide("StrOdenekSonGun");
                    }
                  });

    },
    Get() {
         let Page = {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      }
this.ActionsFilterGet({ Service: "StrParam", Page: Page, Filter: "&Tip=1" }).then(res => {
        this.FormData = res.Data[0];
      });
    },


  },
  created() {
this.Get();

  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrOdenekSonGun"
      size="md"
      title="Son Gün"
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-md-12">
            <forminput
              :FormDataType="FormDataType.Value"
              :Value="FormData.Value"
              :v="$v.FormData.Value"
              @input="FormData.Value = $event"
            />
          </div>
        </div>

        <button class="btn btn-primary" type="submit">
          {{ $t("StrOdenekTalep.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>

<style>
.disabled {
  pointer-events: none;
  opacity: 0.85;
}
.custom-col {
  flex: 0 0 14%; /* 1.5 sütuna denk gelir (12 sütunun %12.5'i) */
  max-width: 14%;
}
.custom2-col {
  flex: 0 0 16%; /* 1.5 sütuna denk gelir (12 sütunun %12.5'i) */
  max-width: 16%;
}
</style>
